export const ITEM_TYPE_LABELS = {
  PRODUCT: 'Producto',
  SERVICE: 'Servicio',
  BOM_PRODUCT: 'Producto con receta'
}

export const ITEM_TYPE_OPTIONS = [
  { value: 'PRODUCT', label: ITEM_TYPE_LABELS.PRODUCT },
  { value: 'SERVICE', label: ITEM_TYPE_LABELS.SERVICE },
  { value: 'BOM_PRODUCT', label: ITEM_TYPE_LABELS.BOM_PRODUCT }
]

export const MOVEMENT_TYPE_LABELS = {
  IN_INITIAL_LOAD: 'Carga inicial',
  IN_MANUAL: 'Entrada manual',
  OUT_SALE: 'Venta',
  OUT_THEFT: 'Robo',
  OUT_MERMA: 'Merma',
  OUT_DAMAGE: 'Dañado',
  OUT_EXPIRED: 'Vencido',
  ADJ_POS: 'Ajuste positivo',
  ADJ_NEG: 'Ajuste negativo',
  TRF_IN: 'Transferencia entrada',
  TRF_OUT: 'Transferencia salida'
}

export const MOVEMENT_TYPE_OPTIONS = [
  { value: 'IN_INITIAL_LOAD', label: MOVEMENT_TYPE_LABELS.IN_INITIAL_LOAD },
  { value: 'IN_MANUAL', label: MOVEMENT_TYPE_LABELS.IN_MANUAL },
  { value: 'OUT_SALE', label: MOVEMENT_TYPE_LABELS.OUT_SALE },
  { value: 'OUT_THEFT', label: MOVEMENT_TYPE_LABELS.OUT_THEFT },
  { value: 'OUT_MERMA', label: MOVEMENT_TYPE_LABELS.OUT_MERMA },
  { value: 'OUT_DAMAGE', label: MOVEMENT_TYPE_LABELS.OUT_DAMAGE },
  { value: 'OUT_EXPIRED', label: MOVEMENT_TYPE_LABELS.OUT_EXPIRED },
  { value: 'ADJ_POS', label: MOVEMENT_TYPE_LABELS.ADJ_POS },
  { value: 'ADJ_NEG', label: MOVEMENT_TYPE_LABELS.ADJ_NEG },
  { value: 'TRF_IN', label: MOVEMENT_TYPE_LABELS.TRF_IN },
  { value: 'TRF_OUT', label: MOVEMENT_TYPE_LABELS.TRF_OUT }
]

export const MANUAL_MOVEMENT_TYPES = [
  'IN_MANUAL',
  'ADJ_POS',
  'ADJ_NEG',
  'OUT_THEFT',
  'OUT_MERMA',
  'OUT_DAMAGE',
  'OUT_EXPIRED'
]

export const MANUAL_MOVEMENT_OPTIONS = MANUAL_MOVEMENT_TYPES.map(value => ({
  value,
  label: MOVEMENT_TYPE_LABELS[value]
}))

export const BOOLEAN_LABELS = {
  true: 'Sí',
  false: 'No'
}

export const STATUS_LABELS = {
  true: 'Activo',
  false: 'Inactivo'
}

export const UNIT_SUGGESTIONS = ['UN', 'KG', 'LT']

export const getItemTypeLabel = value => ITEM_TYPE_LABELS[value] || value || '-'

export const getMovementTypeLabel = value => MOVEMENT_TYPE_LABELS[value] || value || '-'

export const getBooleanLabel = value => (value ? BOOLEAN_LABELS.true : BOOLEAN_LABELS.false)

export const getStatusLabel = value => (value ? STATUS_LABELS.true : STATUS_LABELS.false)
